import { ApiMethods, ERROR_MESSAGE } from "../utils/constants"
import { ApiRequest } from "./api-request"

export async function saveSchedule(data) {
  try {
    // await new Promise((res) => { setTimeout(() => { res() }, 2000) })

    const response = await ApiRequest({
      url: "/schedule/save",
      method: ApiMethods.POST,
      data,
    })
    const responseData = response.data

    console.log("response 12345", responseData)
    // await Promise((res) => setTimeout(() => res(), 1000))
    // const result = [{ name: "Ravi", password: "Test@123", role: "Doctor", profileUrl: "img", email: "ravi@gmail.com" }]
    // return { result }

    if (responseData.status === "Failure") {
      return { error: { message: responseData.message || ERROR_MESSAGE } }
    }
    return responseData.result

    return responseData
  } catch (error) {
    console.log("err", error)
    return { error }
  }
}


export async function updateSchedule(data) {
  try {

    const response = await ApiRequest({
      url: "/schedule/update",
      method: ApiMethods.PUT,
      data,
    })
    const responseData = response.data

    if (responseData.status === "Failure") {
      return { error: { message: responseData.message || ERROR_MESSAGE } }
    }
    return responseData.result

  } catch (error) {
    console.log("err", error)
    return { error }
  }
}

export async function getAllSchedules(data) {
  try {
    // await new Promise((res) => { setTimeout(() => { res() }, 2000) })

    const response = await ApiRequest({
      url: "/schedule/getAll",
      method: ApiMethods.GET,
      params: data,
    })
    const responseData = response.data

    console.log("response 12345", responseData)
    // await Promise((res) => setTimeout(() => res(), 1000))
    // const result = [{ name: "Ravi", password: "Test@123", role: "Doctor", profileUrl: "img", email: "ravi@gmail.com" }]
    // return { result }

    if (responseData.status === "Failure") {
      return { error: { message: responseData.message || ERROR_MESSAGE } }
    }
    return responseData.result

    return responseData
  } catch (error) {
    console.log("err", error)
    return { error }

    const result = [
      {
        name: "Ravi",
        password: "Test@123",
        role: "Doctor",
        profileUrl: "img",
        email: "ravi@gmail.com",
      },
    ]

    return { result }
  }
}

export async function getScheduleById(data) {
  try {
    // await new Promise((res) => { setTimeout(() => { res() }, 2000) })

    const response = await ApiRequest({
      url: "/user/getAllById",
      method: ApiMethods.GET,
      params: data,
    })
    const responseData = response.data

    console.log("response 12345", responseData)
    // await Promise((res) => setTimeout(() => res(), 1000))
    // const result = [{ name: "Ravi", password: "Test@123", role: "Doctor", profileUrl: "img", email: "ravi@gmail.com" }]
    // return { result }

    if (responseData.status === "Failure") {
      return { error: { message: responseData.message || ERROR_MESSAGE } }
    }
    return responseData.result

    return responseData
  } catch (error) {
    console.log("err", error)
    return { error }

    const result = [
      {
        name: "Ravi",
        password: "Test@123",
        role: "Doctor",
        profileUrl: "img",
        email: "ravi@gmail.com",
      },
    ]

    return { result }
  }
}

export async function getSurgeryTypes(data) {
  try {
    const response = await ApiRequest({
      url: "/surgeryTypes/getAll",
      method: ApiMethods.GET,
      params: data,
    })
    const responseData = response.data

    if (responseData.status === "Failure") {
      return { error: { message: responseData.message || ERROR_MESSAGE } }
    }
    return responseData.result

  } catch (error) {
    console.log("err", error)
    return { error }
  }
}